export default (fields) => {
  return fields.reduce((array, { items }) => array.concat(items), []);
};
